

import servicesCreate from './module/serviceCreate'
import serviceUpdate from './module/serviceUpdate'
import serviceChangeHistory from './module/serviceChangeHistory';
import getNextNumerView from '../../../core/static/module/numberRange';
import ArchiveManager from '../../../assets/js/common/ArchiveModal';
import ActivitiesList from '../../../activities/static/js/module/ActivitiesList';
import checkReferences from '../../../assets/js/common/CheckReferences';
import designationNumber from '../../../assets/js/common/DesignationNumber';

document.addEventListener('DOMContentLoaded', function () {
    const servicecreate = new servicesCreate();
    const serviceupdate = new serviceUpdate();
    const servicechangehistory = new serviceChangeHistory();

    // Aktivitäten
    if(document.getElementById('activities-service-container')){
        const activitieslist = new ActivitiesList(activitiesList, 'activities-service-container');
        window.reloadActivitiesList = function () {
            if (typeof activitieslist !== 'undefined' && activitieslist) {
                activitieslist.init();
            }
        };
    }
    
    // Benutzer rechte
    if(typeof serviceId !== 'undefined' && serviceId){
        if(document.querySelector('[data-permission="delete_services"]')){
            checkReferences('services', 'Service', serviceId);
            // Archivieren
            const archiveBtn = document.getElementById('archiveBtn');
            if(archiveBtn) {
                const archiveManager = new ArchiveManager(archiveBtn);
                archiveBtn.addEventListener('click', () => {
                    const url = archiveBtn.getAttribute('data-archive'); 
                    archiveManager.toggleArchive(url)
                });    
            };

        }
    }
    
    // Bezeichnungsnummer
    designationNumber((form) => {
        getNextNumerView('SER', 'serviceCreateForm');
    }, 'serviceCreateForm');

}); 